import { FunctionComponent } from "react";

interface IArticleProps {
  article: Record<any, any>;
}

const Article: FunctionComponent<IArticleProps> = ({ article }) => (
  <article className="bg-white shadow-md rounded-lg p-6 mb-8 hover:shadow-lg transition-shadow duration-300">
    {/* Title */}
    <h2 className="text-2xl font-bold text-gray-800 mb-2">{article.title}</h2>

    {/* Author */}
    <h4 className="text-sm text-gray-500 mb-4">By {article.author}</h4>

    {/* Tags */}
    <div className="mb-4">
      <p className="text-sm font-semibold text-gray-600 mb-2">Tags:</p>
      <div className="flex flex-wrap gap-2">
        {article.tags.map((tag: string, index: number) => (
          <span
            key={index}
            className="bg-blue-100 text-blue-800 text-xs font-medium px-2 py-1 rounded"
          >
            {tag}
          </span>
        ))}
      </div>
    </div>

    {/* Article content */}
    <div className="space-y-6">
      {article.headers.map((header: string, index: number) => (
        <section key={index}>
          <h3 className="text-lg font-semibold text-gray-700 mb-2">{header}</h3>
          <div className="space-y-1 text-gray-600">
            {article.content[index]?.map((content: string, idx: number) => (
              <p key={idx}>{content}</p>
            ))}
          </div>
        </section>
      ))}
    </div>
  </article>
);

export default Article;
